var exports = {
  "V": "xe533113f--738744--inline-factoid",
};

module.exports = exports;
